<div class="feature-list-container" *ngIf="device">
  <div class="content">
    <div class="header">
      <div class="count" *ngIf="device.products as features">
        {{ 'feature.count' | translate:{features: features.length} }}
      </div>
    </div>
    <div class="card">
      <div class="feature-card" *ngFor="let feature of features">
        <kion-feature-list-item
          style="height: 100%"
          [device]="device"
          [feature]="feature"
          [cart]="cart"
          [roles]="roles"
          (addToCart)="addToCartClicked($event)"
        ></kion-feature-list-item>
      </div>
    </div>
  </div>
</div>
